import { styled } from '@mui/material/styles';

export const Container = styled('div')(() => ({
  flex: '1 1 0',
  overflow: 'auto',
  height: '100%',

  '& > .controls-vertical': {
    height: '100%',
  },

  '& .controls-horizontal': {
    gap: '24px',
  },
}));
